import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getFiscalizerList as getFiscalizerListApi,
	addNewFiscalizerApi,
	updateFiscalizerApi,
	deleteFiscalizerApi,
} from '../../helpers/fiscalizer/api_helper';

export const getFiscalizerList = createAsyncThunk(
	'fiscalizer/getFiscalizerList',
	async () => {
		try {
			const response = await getFiscalizerListApi();
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener fiscalizadores.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const addNewFiscalizer = createAsyncThunk(
	'fiscalizer/addNewFiscalizer',
	async fiscalizer => {
		try {
			const response = await addNewFiscalizerApi(fiscalizer);
			toast.success('Fiscalizador agregado correctamente.', { autoClose: 3000 });
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar fiscalizador.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updateFiscalizer = createAsyncThunk(
	'fiscalizer/updateFiscalizer',
	async fiscalizer => {
		try {
			const response = await updateFiscalizerApi(fiscalizer);
			toast.success('Fiscalizador actualizado correctamente.', { autoClose: 3000 });
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar fiscalizador.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteFiscalizer = createAsyncThunk(
	'fiscalizer/deleteFiscalizer',
	async fiscalizer => {
		try {
			await deleteFiscalizerApi(fiscalizer._id);
			toast.success('Fiscalizador eliminado correctamente.', { autoClose: 3000 });
			return fiscalizer;
		} catch (error) {
			toast.error('Error al eliminar fiscalizador.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);
